import Vue from 'vue'
import Vuex from 'vuex'
// import indexedDBPlugin from ''

import createPersistedState from "vuex-persistedstate"
import GlobalVar from '../store/modules/globalVariables'
import auth from './modules/auth'
import Analyse from './modules/clinique/analyses'
import Assurances from './modules/clinique/assurances'
import Consultation from './modules/clinique/consultations'
import Examens from './modules/clinique/examens'
import FileAttente from './modules/clinique/file-attente'
import Patient from './modules/clinique/patients'
import Prescription from './modules/clinique/prescriptions'
import Prestation from './modules/clinique/prestation'
import SoinsHospitalisation from './modules/clinique/soin_hospitalisation'
import Comptable from './modules/comptabilite/comptable'
import Compte from './modules/comptabilite/compte'
import Configs from './modules/comptabilite/configs'
import Depot from './modules/comptabilite/depot'
import Exploitations from './modules/comptabilite/exploitations'
import Operations from './modules/comptabilite/operation'
import Proforma from './modules/comptabilite/proforma'
import RapportCaisse from './modules/comptabilite/rapport-caisse'
import Config from './modules/config/config'
import Produits from './modules/stock/produits'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        Consultation, GlobalVar, Patient,
        Analyse, Examens, Assurances,
        Operations, Compte, SoinsHospitalisation,
        Produits, auth, Prescription, Exploitations,
        Config, Comptable, Depot, Proforma, Prestation,
        Configs, RapportCaisse,
        FileAttente,
    },
    plugins: [createPersistedState()]
})